import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login, startSession, resendVerification } from '../services/api';
import '../styles/AuthPage.css';

function LoginPage() {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  // Set when redirected here by an expired session.
  const [error, setError] = useState(
    new URLSearchParams(window.location.search).has('expired')
      ? 'Your session expired. Please sign in again.'
      : '',
  );
  const [needsVerification, setNeedsVerification] = useState(false);
  const [resent, setResent] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!identifier.trim()) {
      setError('Please enter your username or email');
      return;
    }
    if (!password) {
      setError('Please enter your password');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const data = await login(identifier.trim(), password);
      startSession(data.user, data.token);
      navigate('/papers');
    } catch (err) {
      const msg = err.response?.data?.error;
      setNeedsVerification(Boolean(err.response?.data?.verification_required));
      setError(msg || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1>PaperBuddy</h1>
        <p className="auth-subtitle">Interactive Academic Paper Reading</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="identifier">Username or email</label>
            <input
              id="identifier"
              type="text"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder="Enter your username or email"
              disabled={loading}
              autoFocus
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          {error && <div className="auth-error">{error}</div>}

          {needsVerification && (
            resent ? (
              <p className="auth-subtitle">A new verification link is on its way.</p>
            ) : (
              <button
                type="button"
                className="auth-link"
                onClick={async () => {
                  await resendVerification(identifier.trim().toLowerCase());
                  setResent(true);
                }}
              >
                Resend verification email
              </button>
            )
          )}

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/forgot-password" className="auth-link">Forgot password?</Link>
          <span className="auth-link-sep">·</span>
          <Link to="/register" className="auth-link">Create an account</Link>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
